import React, { useState } from "react";
import "./style.sass";

export const ChoosePopup = ({ onClose, onProceed }) => {
  const [selectedOption, setSelectedOption] = useState("question_bank");

  const options = [
    {
      id: "question_bank",
      title: "Choose question from the question bank",
      description: "Browse and select questions directly from the structured question bank.",
      badge: "QUESTION BANK",
      theme: "green",
      headerLineClass: "header_line_green",
      badgeClass: "green",
      bannerBgClass: "green_bg",
      icon: (
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        </svg>
      ),
    },
    {
      id: "ai_generated",
      title: "Choose question from the AI generated questions",
      description: "Select questions from the pool of 45000+ AI generated & curated questions.",
      badge: "AI POWERED",
      theme: "purple",
      headerLineClass: "header_line_purple",
      badgeClass: "purple",
      bannerBgClass: "purple_bg",
      icon: (
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
          <path d="M20 3v4M18 5h4" />
        </svg>
      ),
    },
  ];

  const handleProceed = () => {
    if (!selectedOption) return;
    const sourceKey = selectedOption === "question_bank" ? "bank" : "ai";
    onProceed(sourceKey);
  };

  return (
    <div className="choose_popup_overlay" onClick={onClose}>
      <div className="popup_box" onClick={(e) => e.stopPropagation()}>
        <button className="close_btn" onClick={onClose} aria-label="Close popup">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <h2>Choose Questions</h2>
        <p className="popup_subtitle">
          Select source to choose questions for your question paper
        </p>

        <div className="qb_cards_selection_grid">
          {options.map((opt) => {
            const isSelected = selectedOption === opt.id;
            return (
              <div
                key={opt.id}
                className={`qb_option_card theme_${opt.theme} ${isSelected ? "selected" : ""}`}
                onClick={() => setSelectedOption(opt.id)}
              >
                <div className={`card_banner ${opt.bannerBgClass}`}>
                  <div className="graphic_mockup">
                    <div className={`mock_line ${opt.headerLineClass}`}></div>
                    <div className="mock_line"></div>
                    <div className="mock_line short"></div>
                    <div className={`banner_badge ${opt.badgeClass}`}>{opt.icon}</div>
                  </div>

                  <div className={`radio_indicator ${isSelected ? "checked" : ""}`}>
                    {isSelected && (
                      <svg
                        width="11"
                        height="11"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ffffff"
                        strokeWidth="3.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    )}
                  </div>
                </div>

                <div className="card_info">
                  <span className={`type_badge badge_${opt.theme}`}>{opt.badge}</span>
                  <h4 className="card_title">{opt.title}</h4>
                  <p className="card_desc">{opt.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="button_group">
          <button type="button" className="cancel_btn" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="upload_btn active"
            onClick={handleProceed}
            disabled={!selectedOption}
          >
            Proceed →
          </button>
        </div>
      </div>
    </div>
  );
};

